<template>

  <div class="padded bg-success-lighten-2">

    <el-form label-position="top" inline>
      <text-input label="Name" v-model="ag.name" />
      <select-structure style="width: 40%" v-model="struct" />
    </el-form>

    <el-row :gutter="56">
      <el-col :span="2" class="bg-success-lighten-1 side-bar" style="padding-bottom: 1.5em;">
        <b class="text-muted">Tables</b>

        <!--              @open="handleOpen"
        @close="handleClose">
      -->
      <el-menu class="inherit-bg" style="border: none;" default-active="1" collapse @select="addToFormula">
        <el-submenu v-for="(m, index) in menu" :key="index" :index="m.value">
          <template #title>
            <i :class="m.icon"></i>
            <span>{{m.label}}</span>
          </template>
          <el-menu-item-group v-for="(g, index) in m.group" :key="index" :title="g.label">
            <el-menu-item v-for="mm in g.children" :key="mm.value" :index="mm.value">
              <!-- eslint-disable-next-line vue/no-v-html -- developer-authored constant menu entries (mm comes from in-file data array) -->
              <span v-html="mm.label"></span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-submenu>

    </el-menu>

  </el-col>

  <el-col :span="22">

    <h4>Formula Area</h4>
    <el-row type="flex" justify="space-between" style="margin-top: 1em; margin-bottom: 1.5em;">
      <el-col align="center" v-for="(op, index) in operators" :key="index">
        <el-button size="large" plain round :type="op.type" :disabled="disabled(op)" @click="addToFormula(op)">{{op.op}}</el-button>
      </el-col>
    </el-row>

    <el-row>

      <el-col :span="24">

        <el-row id="formula-box" :gutter="8">
          <i v-if="formula.length === 0"  class="text-muted text-center">Drop your operators and fields here</i>
          <el-col v-for="(fn, index) in formula"  :key="index" :span="calcSpan(fn)"  align="center">

            <el-tooltip :content="fn.text + (fn.table ? ' from ' + fn.table + ' table' : '')" placement="bottom">
              <span class="formula" :class="fn.class"><span v-if="fn.table">{{fn.table}}&nbsp;</span>{{fn.text}}</span>
            </el-tooltip>

          </el-col>
        </el-row>

        <span v-if="opCount > 0">{{opCount + ' bracket' + (opCount > 1 ? 's' : '') + ' open'}}</span>

        <el-tooltip content="Clear the formula">
          <el-button v-if="formula.length > 0" class="pull-right" type="text" icon="fa fa-eraser" @click="clearFormula()" />
        </el-tooltip>

        </el-col>

      </el-row>

    </el-col>

  </el-row>

  <el-row v-if="formula.length > 0">
    <hr />

    <el-col :span="24">
      Select Example Site: <select-site v-model="site" no-form />
      <div v-if="site">
        <h4>Example:</h4>

        <el-table
        v-if="tableData.length > 0 && tableData[0].field1"
        :data="tableData"
        stripe
        style="width: 100%">

        <el-table-column
        prop="field1"
        label="Field1"
        width="123">
      </el-table-column>

      <el-table-column
      prop="op"
      label="Operator">
    </el-table-column>

    <el-table-column
    prop="field2"
    width="123"
    label="Field 2">
  </el-table-column>

  <el-table-column
  prop="result"
  width="123"
  label="Result">
</el-table-column>


</el-table>
</div>

</el-col>
</el-row>

</div>

</template>

<script>

import {settings} from '@/components/Data'

import ArrayMixins from '@/mixins/ArrayMixins'
import ElTableMixins from '@/mixins/ElTableMixins'
import NumberMixins from '@/mixins/NumberMixins'

import SelectSite from '@/components/atoms/selects/SelectSite'
import SelectStructure from '@/components/atoms/selects/SelectStructure'

export default {
  mxins: [ArrayMixins, ElTableMixins, NumberMixins],

  components: {
    SelectSite,
    SelectStructure
  },

  methods: {
    calcSpan (item) {
      if (this.itemType(item) === 'field') {
        return 6
      } else {
        return 1
      }
    },



    canAdd (item) {

      if (this.emptyFormula()) {
        return true
      }


      if (item.multiple) {
        return true
      }

      let prev = this.last()

      let eq = (prev && prev.data && (prev.data.needsOpAfter || prev.data.needsOpAfter || prev.data.multiple))

      if (eq && this.itemType(item) === this.itemType(prev)) {
        return true
      } else {
        if (this.itemType(item) !== this.itemType(prev)) {
          return true
        } else {
          return false
        }
      }
    },



    clearFormula () {
      this.formula = []
      this.opCount = 0
    },



    emptyFormula () {
      return (this.formula.length === 0)
    },



    disabled (item) {
      let dis = this.emptyFormula()

      if (item.multiple) {
        return false
      }

      if (item && item.op === '(') {
        dis = (!(this.itemType(this.last()) !== 'operator') || !this.emptyFormula())
//        console.log('(', dis, (this.itemType(this.last()) === 'operator'), this.emptyFormula())
      }

      if (item && item.op === ')') {
        dis = (this.opCount === 0)
      }

      return dis
    },



    last () {
      return this.formula[this.formula.length - 1]
    },



    itemType (item) {

      if (item) {

        if (item.data) {
          return 'operator'
        } else {
          return 'field'
        }

      } else {
        return 'unknown'
      }
    },


    addToFormula (item) {
      let i = this.formatFormulaItem(item)

      if (this.canAdd(i)) {

        this.formula.push(i)

        if (i.data && i.data.countStart) {
          this.opCount++
        }

        if (i.data && i.data.countStop) {
          this.opCount--
        }

      } else {
        this.$message({type: 'info', message: 'Can\'t add the same type twice'})
      }
    },


    removeFromFormula (index) {
      let item = this.formula[index]

      self.$confirm('Are you sure you want to remove ' + item + ' from the formula?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        center: true,
        type: 'warning'
      }).then(() => {

        this.arrayRemove(this.formula, index)

      })
    },


    formatFormulaItem (addItem) {

      let item = this.clone(addItem)
      let div = {text: null}

      div.class = `text-${item.type}`
      div.isField = (item.op ? false : true)

      if (item) {
        if (item.op) {  // We have a smooth operator boys!
          div.text = item.op

          delete item.op
          delete item.type

          if (item) {   // any other data in the object.
            div.data = item
          }

        } else {
          // Database field
          div.class = 'field'
          div.table = item.split('.')[0]
          div.text = item.slice(item.lastIndexOf('.') + 1)
        }
      }

      return div
    }

  },


  data () {
    return {
      taxLabel: settings.taxName,
      taxRate: Number(settings.taxRate) / 100,
      interestRate: settings.interestRate,
      ag: this.getTableStruct('agreements'),
      formula: [],
      tableData: [{field1: null, op: null, field2: null, result: null}],
      site: null,
      struct: null,
      messages: [],
      opCount: 0,
      operators: [
        {op: '+', type: 'primary'},
        {op: '-', type: 'danger'},
        {op: 'x', type: 'warning', native: '*'},
        {op: '÷', type: 'info', native: '/'},
        {op: '(', type: 'primary', needsOpPrior: true, countStart: true, multiple: true},
        {op: ')', type: 'warning', needsOpAfter: true, countStop: true, multiple: true}
      ],
      menu: [
        {
          label: 'Site',
          icon: 'fa fa-map-marker',
          value: 'sites',
          group: [
            {
              label: 'Site',
              children: [
                {
                  label: 'Sharers',
                  value: 'sites.stats.sharers'
                },
                {
                  label: 'Rate ID',
                  value: 'sites.rate_id'
                },
                {
                  label: 'Rate Group',
                  value: 'sites.rateGroupId'
                },
                {
                  label: 'Structure Name',
                  value: 'sites.structure.name'
                },
                {
                  label: 'Structure Weight',
                  value: 'sites.structure.weight'
                },
                {
                  label: 'Structure Height',
                  value: 'sites.structure.height'
                },
                {
                  label: 'Structure Levels',
                  value: 'sites.structure.levels'
                },
                {
                  label: 'Years Active',
                  value: 'sites.stats.yearsActive'
                },
                {
                  label: 'Months Active',
                  value: 'sites.stats.monthsActive'
                }
              ]
            }
/*
            {
              label: 'Site Rental',
              children: [
                {
                  label: 'Deposit',
                  value: 'sites.landDeposit'
                },
                {
                  label: 'Total Renewals',
                  value: 'tenancy.count[]'
                },
                {
                  label: 'Monthly Rental',
                  value: 'sites.landValue'
                },
                {
                  label: 'Total Tenancy Years',
                  value: 'sites.totalTenancyYears'
                },
                {
                  label: 'Total Tenancy Months',
                  value: 'sites.totalTenancyMonths'
                },
                {
                  label: '# Renewals',
                  value: 'sites.term'
                }
              ]
            }
*/
          ]
        },
        {
          label: 'Sharers',
          icon: 'fa fa-share-alt',
          value: 'sharers',
          group: [
            {
              label: 'Sharer',
              children: [
                {
                  label: 'Sharer No',
                  value: 'sharers.sharerNo'
                },
                {
                  label: 'Current Rate',
                  value: 'sharers.currentRate'
                },
                {
                  label: 'Sharer Interest Rate',
                  value: 'sharers.interestRate'
                },
                {
                  label: 'CAPEX',
                  value: 'sharers.capex'
                },
                {
                  label: 'OPEX',
                  value: 'sharers.opex'
                },
                {
                  label: 'Discount',
                  value: 'sharers.discount'
                },
                {
                  label: 'Discount %',
                  value: 'sharers.discountPercentage'
                },
                {
                  label: 'Total Equipment',
                  value: 'sharers.assets.count[]'
                },
                {
                  label: 'Total Cabins',
                  value: 'sharers.assets.count[Cabins]'
                },
                {
                  label: 'Total Own Meter',
                  value: 'sharers.assets.count[Own Meter]'
                },
                {
                  label: 'Total Gensets',
                  value: 'sharers.assets.count[Gensets]'
                },
                {
                  label: 'Total RRU',
                  value: 'sharers.assets.count[RRU]'
                },
                {
                  label: 'Total RRB',
                  value: 'sharers.assets.count[RRB]'
                },
                {
                  label: 'Total RF Panels',
                  value: 'sharers.assets.count[RF]'
                },
                {
                  label: 'Total AAU Panels',
                  value: 'sharers.assets.count[AAU]'
                },
                {
                  label: 'Total Antenna',
                  value: 'sharers.assets.count[Antenna]'
                },
                {
                  label: 'Total MW',
                  value: 'sharers.assets.count[Backhaul|MW]'
                }
              ]
            }
          ]
        },
/*
        {
          label: 'Property',
          icon: 'fa fa-warehouse',
          value: 'property',
          group: [
            {
              label: 'Property Info',
              children: [
                {
                  label: 'Renewal Term',
                  value: 'tenancy.period'
                },
                {
                  label: 'Amount',
                  value: 'tenancy.amount'
                },
                {
                  label: 'Tax',
                  value: 'tenancy.tax'
                },
                {
                  label: 'Total',
                  value: 'tenancy.total'
                }
              ]
            }
          ]
        },
*/
        {
          label: 'Settings',
          icon: 'fa fa-user-cog',
          value: 'settings',
          group: [
            {
              label: 'Settings',
              children: [
                {
                  label: `${settings.taxName} (<i>${settings.taxRate}%</i>)`,
                  value: `salesTax.[${settings.taxRate}%]`
                },
                {
                  label: `Interest Rate (<i>${settings.interestRate}%</i>)`,
                  value: `interestRate.[${settings.interestRate}%]`
                }
              ]
            }
          ]
        }
      ]
    }
  }

}

</script>

<style scoped>

#formula-box {
  position: relative;
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  padding-top: 0.7em;
  border: dashed darkgrey;
  background: ivory;
  min-height: 33px;
  max-height: inherit;
  height: inherit;
  width: 100%;
}

.formula {
  font-size: 18pt;
  font-weight: bold;
}

.field {
  display: inline-block;
  text-align: left;
  width: 100%;
  padding-top: 5px;
  color: white;
  font-size: 1.2em;
  border-radius: 20px;
  background: #73AD21;
}

.field > span {
  position: relative;
  top: -17px;
  left: 8px;
  border: 0.5px dotted green;
  padding: 0.5em;
  font-style: italic;
  font-weight: lighter;
  color: #0f0f0f;
  font-size: 0.5em;
  border-radius: 10px;
  background: #e9f7d6;
}

.ribbon1 {
  position: absolute;
  top: -6.1px;
  right: 10px;
}
.ribbon1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-left: 53px solid transparent;
  border-right: 53px solid transparent;
  border-top: 10px solid #F8463F;
}
.ribbon1 span {
  position: relative;
  display: block;
  text-align: center;
  background: #F8463F;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-top-right-radius: 8px;
  width: 90px;
}
.ribbon1 span:before, .ribbon1 span:after {
  position: absolute;
  content: "";
}
.ribbon1 span:before {
 height: 6px;
 width: 6px;
 left: -6px;
 top: 0;
 background: #F8463F;
}
.ribbon1 span:after {
 height: 6px;
 width: 8px;
 left: -8px;
 top: 0;
 border-radius: 8px 8px 0 0;
 background: #C02031;
}


.side-bar {
  border-top-right-radius: 17px;
  border-bottom-right-radius: 17px;
  padding-top: 2em;
}
</style>
